import Style from '../assets/css/contact.module.css';
import Mail from './email';
import Social from './social';

const Contact = () => {

    return (
       <> 
        <section className ={Style.Container}>
            <section className = {Style.SocialSection}>
            <Social/>
            <Mail/>
            </section>
        </section>
        </>
    )

};

export default Contact;